export const CENTER_LEADER_FIELD_NAMES = {
  SECONDARY_LEADER: 'employeeEnrollment2Leader',
  ADMINISTRATIVE_LEADER: 'employeeEnrollmentAdministrative',
};
